import { Bonus, EMPLOYMENT_PERIOD_UNIT, PAYMENT_FREQUENCY } from "./bonus.dto";
import { PayrollCompanyDto } from "./company-account.dto";
import { PaginatorInfo } from "./generic.dto";

type BonusGroup = {
  id: number;
  companyId: number;
  code: string;
  name: string;
  description: string;
  createdAt: Date;
  modifiedAt: Date | null;
}

export class CreateBonusGroupDto {
  code!: string;
  name!: string;
  description!: string;
  prorate!: boolean;
  periodStartDate!: Date;
  periodEndDate!: Date;
  minEmploymentPeriod?: number;
  employmentPeriodUnit?: EMPLOYMENT_PERIOD_UNIT
  paymentFrequency?: PAYMENT_FREQUENCY
  paymentInstance?: number;
  minValue!: number;
  maxValue?: number;
  active!: boolean;
  currencyId!: number;
}

export interface BonusGroupDto extends BonusGroup {
  company?: PayrollCompanyDto;
  bonuses?: Bonus[];
}

export class UpdateBonusGroupDto {
  code?: string;
  name?: string;
  description?: string;
  prorate?: boolean;
  periodStartDate?: Date;
  periodEndDate?: Date;
  minEmploymentPeriod?: number;
  employmentPeriodUnit?: EMPLOYMENT_PERIOD_UNIT
  paymentFrequency?: PAYMENT_FREQUENCY
  paymentInstance?: number;
  minValue?: number;
  maxValue?: number;
  active?: boolean;
  currencyId?: number;
}

export enum BonusGroupOrderBy {
  CREATED_AT_ASC = 'createdAt:asc',
  CREATED_AT_DESC = 'createdAt:desc',
  MODIFIED_AT_ASC = 'modifiedAt:asc',
  MODIFIED_AT_DESC = 'modifiedAt:desc',
  CODE_ASC = 'code:asc',
  CODE_DESC = 'code:desc',
  NAME_ASC = 'name:asc',
  NAME_DESC = 'name:desc',
}

export class QueryBonusGroupDto {
  page?: number = 1;
  limit?: number;
  orderBy: BonusGroupOrderBy = BonusGroupOrderBy.CREATED_AT_ASC;
}

export class SearchBonusGroupDto {
  q?: string
  page?: number = 1;
  limit?: number;
  orderBy: BonusGroupOrderBy = BonusGroupOrderBy.CREATED_AT_ASC;
}

export interface BonusGroupPaginator extends PaginatorInfo<BonusGroupDto> {}
